/* eslint-disable react-hooks/exhaustive-deps */
import React, {useMemo} from 'react';
import {connect} from 'react-redux';
import {isObjectEmpty} from '../../../helpers/isObjectEmpty';
import {info_Green} from 'assets/images/images';

const GovernmentData = ({widgets: {widgetPages, widgetScreen}}) => {
  const widgetData =
    widgetPages &&
    widgetPages?.find(
      widget =>
        widget?.page === 'government-data' &&
        widget?.pageId === widgetScreen?.pageId,
    );

  const data = useMemo(
    () => ({
      ...widgetData?.config,
      mobile: widgetData?.config?.mobile,
    }),
    [
      widgetData?.config?.mobile,
      widgetData?.config?.selfie,
      widgetData?.config?.otp,
      widgetData?.config?.bvn,
      widgetData?.config?.vnin,
      widgetData?.config?.dl,
      widgetData?.config?.type,
    ],
  );

  return (
    <>
      <header className="flex flex-col items-center mt-9">
        <div className="flex items-center gap-2 py-1 px-2 bg-[#E2F5F6] rounded-full">
          <img src={info_Green} alt="" width={20} height={20} className="" />
          <p className="text-sm rounded-lg text-[#4A878D] font-medium  ">
            Fill the form as it appears on your valid ID
          </p>
        </div>
      </header>
      <form className="w-full max-w-sm mt-10 px-6">
        <label
          htmlFor="government_data"
          className="mb-2 text-[#1B2A4E] text-sm font-normal"
        >
          Government data
        </label>
        <select
          name="government_data"
          id="government_data"
          className="font-medium text-[#8D8D91] bg-[#F9F9F9] text-sm rounded w-full p-3"
        >
          {data?.bvn && <option value="bvn">Bank Verification Number</option>}
          {data?.nin && (
            <option value="nin">National Identification Number</option>
          )}
          {data?.dl && <option value="dl">Driver&apos;s License</option>}
          {data?.mobile && <option value="mobile">Phone Number</option>}
        </select>
        <label
          htmlFor="id_type"
          className="mt-4 mb-1 text-[#1B2A4E] text-sm font-normal"
        >
          BVN Number
          <input
            type="text"
            id="id_type"
            value="10253665114"
            readOnly
            className="mt-2 text-sm text-[#8D8D91] bg-[#F9F9F9] rounded w-full p-3"
          />
        </label>
        <label
          htmlFor="verify_with"
          className="mb-2 mt-4 text-[#1B2A4E] text-sm font-normal"
        >
          Verify With
        </label>
        <select
          name="verify_with"
          id="verify_with"
          className="font-medium text-[#8D8D91] bg-[#F9F9F9] text-sm rounded w-full p-3"
        >
          {(!data || isObjectEmpty(data) || data?.otp || data?.bvnAdvance) && (
            <option value="otp">OTP (One-time Password)</option>
          )}
          {(!data || isObjectEmpty(data) || data?.type) && (
            <option value="selfie">
              Take a {data?.type === 'basic' ? 'selfie' : 'video'}
            </option>
          )}
        </select>
      </form>
    </>
  );
};

export default connect(state => state, null)(GovernmentData);
